module.exports = __webpack_public_path__ + "static/apartment_350-f51a706498bf0129509a61960913b1c2.jpg";